'use strict';

import { Entity } from '../Entity';
import { Ind } from './Ind';

export class IndPolicyGroup extends Entity {
  protected id;

  protected ind;

  protected policy;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    if (data.ind) {
      const ind = new Ind();

      ind.hydrate(data.ind);

      this.ind = ind;
    }

    this.policy = data.policy;
  }

  public getId() {
    return this.id;
  }

  public getInd() {
    return this.ind;
  }

  public getPolicy() {
    return this.policy;
  }
}
